import { icons } from '@attendu/icons';

const FALLBACK = 'star-06';

export default function safeIconName(name) {
  return name && name in icons ? name : FALLBACK;
}
